export const setEnteredPlannedValue = (value) => {
  return { type: "SET_ENTERED_PLANNED_VALUE", payload: value };
};
